import { type ReactElement } from "react"
import { StoryblokHeadlessLayout } from "../components/StoryblokHeadlessLayout"
import { StoryblokLayout, type StoryblokLayoutProps } from "../components/StoryblokLayout"

export function getStoryblokLayout(page: ReactElement<StoryblokLayoutProps>) {
    return <StoryblokLayout {...page.props}>{page}</StoryblokLayout>
}

export function getStoryblokHeadlessLayout(page: ReactElement<StoryblokLayoutProps>) {
    return <StoryblokHeadlessLayout {...page.props}>{page}</StoryblokHeadlessLayout>
}

getStoryblokLayout.messages = [...StoryblokLayout.messages] as const
